<template>
  <div v-if="config">
    <el-cascader 
      :class="`${customize && state[k] === false ? 'input-bd0' : ''}`"
      :style="`width:${width}`"
      :props="{
        checkStrictly: arbitrary,
        multiple: mulitiple,
        label: labelKey,
        value: valueKey
      }" :show-all-levels="false" 
      :size="size" 
      v-model="value"  
      :options="list" 
      @change="handleChange"
      @focus="changeState" 
      @blur="changeState">
    </el-cascader>
  </div>
</template>
<script>
const configType = {
  team: {
    listFn: 'getDepartmentList',
    listName: 'departmentList',
    mapName: 'departmentMap',
    module: 'Organize'
  },
  permission: {
    listFn: 'getPermList',
    listName: 'permList',
    module: 'Permission',
    headPointer: {
      id: 0,
      name: '顶级权限'
    }
  },
  menu: {
    listFn: 'getMenuList',
    listName: 'menu',
    module: 'Menu',
    headPointer: {
      id: 0,
      name: '顶级菜单'
    }
  }
}
import {deepClone} from '@/util'
export default {
  props: {
    type: {
      type: String,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    k: {
      type: String,
      required: true
    },
    mulitiple: {
      type: Boolean,
      default: false
    },
    state: {
      type: Object,
      default: () => {}
    },
    customize: {
      type: Boolean,
      default: true
    },
    labelKey: {
      type: String,
      default: 'name'
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    size: {
      type: String,
      default: 'small'
    },
    width: {
      type: String,
      default: '180px'
    },
    arbitrary: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      value: []
    }
  },
  created() {
    this.getList()
    if(this.transIndex()) {
      this.initValue(this.form.index[0],this.list)
    }
  },
  computed: {
    config() {
      return configType[this.type]
    },
    list() {
      const baseList = this.$store.state[this.config.module][this.config.listName]
      if(this.config.headPointer) {
        return [this.config.headPointer,...baseList]  
      }else {
        return baseList
      }
    },
    map() {
       return this.$store.state[this.config.module][this.config.mapName]
    },
  },
   methods: {
    getList() {
      this.$store.dispatch(this.config.listFn)
    },
    transIndex() {
      const form = this.form
      if(form.index) {
        form.index = form.index.split('-')
        if(form.index.length === 0) {
          return false
        } else {
          return true
        }
      }
    },
    initValue(i,list) {
      if(this.config.headPointer && this.form.index.length === 1) {
        return this.value = [this.config.headPointer[this.valueKey]]
      }
      if(this.config.headPointer) i = Number(i) + 1
      const indexs = this.form.index
      this.value.push(list[i][this.valueKey])
      const children = list[i].children
      if(indexs[i + 1] && children && children.length > 0 ) {
        this.initValue(indexs[i + 1], list[i].children)
      }
    },
    handleChange(arr) {
      this.form[this.k] = arr[arr.length - 1]
    },
    changeState() {
      if(this.customize) this.$emit( 'stateCB' , this.k)
    }
  },
  watch: {
    form(nV) {
      this.value = []
      if(this.transIndex()) {
        this.initValue(this.form.index[0],this.list)
      }
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Util/CascaderUtil.vue